import { ModulesEnum } from '../enums/modules.enum';

export const LIST_COLUMNS_SETTINGS_KEY = 'listColumns';

export type ListColumnPreferences = Partial<Record<ModulesEnum, string[]>>;

const MODULE_IDS = new Set<string>(Object.values(ModulesEnum));

function parseColumnIds(raw: unknown): string[] | undefined {
  if (!Array.isArray(raw)) {
    return undefined;
  }

  const ids: string[] = [];
  const seen = new Set<string>();
  for (const id of raw) {
    if (typeof id !== 'string' || id.length === 0 || seen.has(id)) {
      continue;
    }
    seen.add(id);
    ids.push(id);
  }
  return ids;
}

export function parseListColumnPreferences(
  raw: unknown,
): ListColumnPreferences {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) {
    return {};
  }

  const preferences: ListColumnPreferences = {};
  for (const [key, value] of Object.entries(raw)) {
    if (!MODULE_IDS.has(key)) {
      continue;
    }
    const columnIds = parseColumnIds(value);
    if (columnIds == null) {
      continue;
    }
    preferences[key as ModulesEnum] = columnIds;
  }
  return preferences;
}

export function listColumnPreferencesToBagValue(
  prefs: ListColumnPreferences,
): Record<string, unknown> {
  return { ...prefs };
}
